import StatsContainer from "../StatsContainer";
import { PageHeading } from "../Ui";
export default function Stats({ onSignIn }) { return <><PageHeading title="The league, by the numbers." description="Every call leaves a record. Here's yours."/><section className="flow-panel"><StatsContainer onSignIn={onSignIn}/></section></>; }
